module.exports = __webpack_public_path__ + "img/user_default.7ea4af7d.png";